import React from 'react'
import Layout from '../Partials/Layout'
import AlertsTable from './AlertsTable'

// Same concept as myfit-app's Alerts page (RD) — was the old vendor
// "Reminders" feature before this, which had no real backend
// (REMINDERS_NOT_IMPLEMENTED in UsersService.js, since removed) and no
// "add" concept, unlike notifications, which are system-generated.
export default function Alerts() {
  return (
    <>
      <Layout>
        <div className="content-wrapper-profile-only w-full mb-6">
          <div className="auth-tab-content relative mb-10">
            <div className="lg:flex justify-between">
              <div className="tab-items"></div>
            </div>
            <div className="hidden lg:block w-full h-[1px] bg-[#DCD5FE] dark:bg-[#5356fb29] absolute top-[42px] left-0"></div>
          </div>
        </div>
        <div className="history-wrapper w-full mb-10">
          <div className="main-wrapper w-full">
            <AlertsTable />
          </div>
        </div>
      </Layout>
    </>
  )
}
